import { render, staticRenderFns } from "./FiBuBuchungGruppierungskonten.vue?vue&type=template&id=13ccff48&"
import script from "./FiBuBuchungGruppierungskonten.vue?vue&type=script&lang=js&"
export * from "./FiBuBuchungGruppierungskonten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports